import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { Reveal, SectionLabel } from "./Motion";
import { Fingerprint, Radio, BrainCircuit, Link2, Store, Ship, Boxes, BadgeCheck, Truck, Leaf, QrCode, LineChart } from "lucide-react";

const ICONS = [Fingerprint, Radio, BrainCircuit, Link2, Store, Ship, Boxes, BadgeCheck, Truck, Leaf, QrCode, LineChart];

export const Capabilities = () => {
  const { t } = useLang();
  const c = t.capabilities;
  return (
    <section id="platform" data-testid="capabilities-section" className="relative py-20 md:py-40 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <SectionLabel>{c.label}</SectionLabel>
            <h2 className="font-cormorant font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[var(--text-primary)] max-w-3xl">
              {c.title}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="font-outfit font-light text-[var(--text-secondary)] leading-relaxed">{c.intro}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {c.items.map((label, i) => {
            const Icon = ICONS[i] || Boxes;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
                data-testid={`capability-${i}`}
                className="group flex items-center gap-4 rounded-2xl border border-[var(--border)] bg-[var(--bg-secondary)]/50 px-5 py-6 hover:border-[var(--gold)]/50 hover:bg-[var(--bg-secondary)] transition-colors duration-400"
              >
                <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-[var(--gold)]/10 group-hover:bg-[var(--gold)]/20 transition-colors duration-400">
                  <Icon className="w-5 h-5 text-[var(--gold)]" strokeWidth={1.4} />
                </span>
                <span className="font-outfit text-sm md:text-base text-[var(--text-primary)]">{label}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
